/**
 *    @tableOfContent
 *      1. Import basic js
 *      2. Import dynamic components
 *
 */

/**
 *   @section 1. Import basic js
 */
// nothing to import


/**
 *   @section 2. Import dynamic components
 */

import('./_App-Scroll-Direction')
.catch(() => {
    console.log("Scroll Direction can't be loaded")
})

import('./_App-Page-Transition')
.catch(() => {
    console.log("Swup can't be loaded")
})

import('./_App-Data-Animate')
.catch(() => {
    console.log("Data Animate can't be loaded")
})

import('./_App-Anchor-Links')
.catch(() => {
    console.log("Anchor-Links can't be loaded")
})

import('./_App-Personio-Jobs')
.catch(() => {
    console.log("Personio Jobs can't be loaded")
})

import('../Button/_Button')
.catch(() => {
    console.log("_Button can't be loaded")
})

import('../Form/Form-Validation')
.catch(() => {
    console.log("Form-Validation can't be loaded")
})

import('../Darkmode/Darkmode')
.catch(() => {
    console.log("Darkmode can't be loaded")
})

import('../Easter-Egg/Browser-Console')
.catch(() => {
    console.log("Browser Console Easter Egg can't be loaded")
})

import('../Accordion/Accordion.js')
.catch(() => {
    console.log("Accordion can't be loaded")
})

import('../Biscuit-Consent/Biscuit-Consent.js')
.catch(() => {
    console.log("Biscuit-Consent can't be loaded")
})

import('../Card/Card.js')
.catch(() => {
    console.log("Card can't be loaded")
})

import('../Carousel/Carousel.js')
.catch(() => {
    console.log("Carousel can't be loaded")
})

import('../Copyright/Copyright.js')
.catch(() => {
    console.log("Copyright can't be loaded")
})

import('../Chip/Chip.js')
.catch(() => {
    console.log("Chip can't be loaded")
})

// import('../Customer-Logos/Customer-Logos.js')
// .catch(() => {
//     console.log("Customer-Logos can't be loaded")
// })

import('../Expand-Wrapper/Expand-Wrapper.js')
.catch(() => {
    console.log("Expand-Wrapper can't be loaded")
})

import('../Form/Field.js')
.catch(() => {
    console.log("Field can't be loaded")
})

import('../Header/Header.js')
.catch(() => {
    console.log("Header can't be loaded")
})

import('../Image/Image.js')
.catch(() => {
    console.log("Image can't be loaded")
})

import('../Modal/Modal.js')
.catch(() => {
    console.log("Modal can't be loaded")
})

import('../Stage/Stage-Accent.js')
.catch(() => {
    console.log("Stage-Accent can't be loaded")
})

import('../Stage/Stage-Default.js')
.catch(() => {
    console.log("Stage-Default can't be loaded")
})

import('../Stage/Stage-Job.js')
.catch(() => {
    console.log("Stage-Job can't be loaded")
})

// import('../Styleguide/Styleguide.js')
// .catch(() => {
//     console.log("Styleguide can't be loaded")
// })

// enf of App.ts file
